import ErrorTrackingChurn from "../../../../contents/blog/_snippets/error-tracking-churn.mdx";
import CaptureExceptions from "../../../../contents/blog/_snippets/capture-exceptions.mdx";
import ErrorTrackingTopCustomers from "../../../../contents/blog/_snippets/error-tracking-top-customers.mdx";
import USEURevenue from "../../../../contents/blog/_snippets/us-eu-revenue.mdx";
import RevenueLifecycle from "../../../../contents/blog/_snippets/revenue-lifecycle.mdx";
import RevenuePerProduct from "../../../../contents/blog/_snippets/revenue-per-product.mdx";
import StartupPlanCustomerCount from "../../../../contents/blog/_snippets/startup-plan.mdx";
import StartupRevenuePerCustomer from "../../../../contents/blog/_snippets/startup-revenue-per-customer.mdx";
import BreachedTickets from "../../../../contents/blog/_snippets/breached-tickets.mdx";
import EscalatedSLA from "../../../../contents/blog/_snippets/escalated-sla.mdx";
import TimeTicketsCreated from "../../../../contents/blog/_snippets/time-tickets-created.mdx";
import OpportunitiesPerQuarter from "../../../../contents/blog/_snippets/opportunities-per-quarter.mdx";
import PipelinePerQuarter from "../../../../contents/blog/_snippets/pipeline-per-quarter.mdx";
import ManagedAccounts from "../../../../contents/blog/_snippets/managed-accounts.mdx";
import StartupCohorts from "../../../../contents/blog/_snippets/startup-cohorts.mdx";
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  ErrorTrackingChurn,
  CaptureExceptions,
  ErrorTrackingTopCustomers,
  USEURevenue,
  RevenueLifecycle,
  RevenuePerProduct,
  StartupPlanCustomerCount,
  StartupRevenuePerCustomer,
  BreachedTickets,
  EscalatedSLA,
  TimeTicketsCreated,
  OpportunitiesPerQuarter,
  PipelinePerQuarter,
  ManagedAccounts,
  StartupCohorts,
  CalloutBox,
  React
};